/** @jsx jsx */

import React from 'react';
// import { css as _css } from 'emotion';
import { css, jsx } from '@emotion/core';
import EmptyBtn from 'components/UI/EmptyBtn';
import { colors } from 'styles/variables';

const { lPink, lGrey1 } = colors;

const EditorBtn = ({ label, onClick, style = {}, ...props }) => {
  let hoverOveride = null;
  if (style['hover']) {
    hoverOveride = Object.keys(style['hover'])
      .map(key => `${key}: ${style['hover'][key]} !important;`)
      .join('');
  }

  return (
    <EmptyBtn
      label={label}
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 35px;
        min-width: 100px;
        padding: 5px 15px;
        border-radius: 9999px;
        outline: none;
        background: ${lPink};
        color: #fff;
        transition: background 0.1s;
        &:hover {
          background: ${lGrey1} !important;
          color: #000 !important;

          ${hoverOveride && hoverOveride}
        }
      `}
      style={style}
      {...props}
      onClick={onClick}
    />
  );
};

export default EditorBtn;
